import React, { useState } from "react";

import ExchangeFlightList from "./components/ExchangeFlightList";
import ExchangeSideBar from "./components/ExchangeSideBar";
import { useLocation, useNavigate } from "react-router-dom";
import { NDCExchangeRequoteReq } from "../NDCRequest/NDCRequest";
import { requoteNDCOrder } from "../Services/NDCApi";
import Loading from "../../Loading";
import { toast } from "react-toastify";
import moment from "moment";

const NDCExchangeFlight = () => {
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  let { exchangeReshop, ticketData, booking, orderItems, retain } =
    location.state;

  const flightInfo = booking?.flight;

  const { reshopOffers, dataMap, augmentations, shoppingResponseId } =
    exchangeReshop;

  const { Passenger = {}, flatSegment = {} } = ticketData;

  const getOffer = (offer) => {
    return offer?.journeyOverviews?.map((journey) => {
      return getJourney(journey?.paxJourneyRefId);
    });
  };

  const getJourney = (ref) => {
    return dataMap?.paxJourneys[ref];
  };

  const getAugmentation = (refs) => {
    console.log(refs);
    return refs?.reduce((acc, ref) => {
      if (augmentations?.[ref]) {
        acc[ref] = augmentations[ref];
      }
      return acc;
    }, {});
  };

  const onSelect = async (offer) => {
    const now = moment();
    const start = moment(offer.offerExpirationDateTime);

    const isCreditTimeRestricted = now.isAfter(start);

    if (isCreditTimeRestricted) {
      toast.error("Offer expired, Please Try Again.");
      navigate(-1);
    }

    const data = {
      ...flightInfo,
      retain,
      orderItems,
      shoppingResponseId,
      passengers: dataMap?.passengers,
      augmentations: getAugmentation(offer?.augRefIds),
    };
    let req = NDCExchangeRequoteReq(offer, data);

    // console.log(JSON.stringify(req, null, 2));

    // req = JSON.stringify(req);

    const res = await requoteNDCOrder(req, offer.ownerCode, setLoading);

    if (res?.Errors?.Error || res?.error) {
      toast.error(
        `Error in exchange reshop
                ${res?.Errors?.Error || res?.error?.code}`
      );
      return;
    }

    navigate("/ndc-exchange-payment", {
      state: {
        exchangeRequote: res.response,
        ticketData,
        booking,
      },
    });
  };

  if (loading) return <Loading />;

  return (
    <div className="mx-12">
      <h1 className="mx-2 mt-3 mb-5 w-1/2 text-2xl font-semibold text-gray-800">
        NDC Exchange Search
      </h1>
      <div className="flex flex-row-reverse gap-3 justify-between">
        <div className="flex flex-col gap-4 items-center mx-2 w-full">
          <p className="text-sm text-red-400 text-start">
            Warning*: This is not the final price. The final price will be seen
            during the payment flow.
          </p>
          {reshopOffers?.map((offer, index) => {
            return (
              <ExchangeFlightList
                key={index}
                offer={offer}
                journeys={getOffer(offer)}
                dataMap={dataMap}
                onSelect={onSelect}
                flightInfo={flightInfo}
              />
            );
          })}
        </div>
        <ExchangeSideBar Passenger={Passenger} flatSegment={flatSegment} />
      </div>
    </div>
  );
};

export default NDCExchangeFlight;
